"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FULFILLMENT_PLUGINS = void 0;
exports.FULFILLMENT_PLUGINS = {
    SHIPSTATION: 'SHIPSTATION',
    CUSTOM_GATEWAY: 'CUSTOM_GATEWAY'
};
//# sourceMappingURL=fulfillmentPlugins.js.map